import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
  index?: number;
}

export default function NewsCard({ item, index = 0 }: NewsCardProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-100 transition-all duration-300 hover:border-primary-500/60 md:flex-row"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative h-48 w-full shrink-0 overflow-hidden bg-background-200 md:h-auto md:w-64">
        <img
          src={item.cover}
          alt={`${item.title} - 午夜电影资讯`}
          title={`${item.title} - 影视资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="mb-3 flex flex-wrap items-center gap-3">
          <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-[11px] font-semibold text-primary-900">
            {item.category}
          </span>
          <span className="text-xs text-foreground-600">{item.date}</span>
        </div>
        <h3 className="mb-2 font-heading text-base font-bold leading-snug text-foreground-50 transition-colors group-hover:text-primary-400 md:text-lg">
          {item.title}
        </h3>
        <p className="mb-4 line-clamp-2 text-sm leading-relaxed text-foreground-500">
          {item.summary}
        </p>
        <span className="mt-auto inline-flex items-center gap-1 text-xs font-semibold text-foreground-400 transition-colors group-hover:text-primary-400">
          阅读全文
          <i className="ri-arrow-right-line"></i>
        </span>
      </div>
    </Link>
  );
}